import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams, useNavigate } from 'react-router-dom'
import EventToolbar from '../eventToolbar/view'
import EventUpsell from '../eventUpsell/view';
import ParticipantList from '../../participantList/view'
import EventModalParticipant from '../eventModalParticipant/view'
import EventTicketUpdate from '../eventTicketUpdate/view'
import ModalCloseButton from '../../../atoms/modalCloseButton/view'
import ExpandableSidebar from '../expandableSidebar/view'
import {
  Container, BackgroundOrb, ContentWrapper, HeroSection, HeroContent,
  HeroGrid, HeroMain, HeroAside, EventHeader, EventIcon, EventInfo,
  DateInfo, DateText, EventTitle, VenueInfo, VenueLink,
  StatsContainer, StatBadge, ShareCard, ShareHeader, ShareTitle,
  QRContainer, DetailsSection, ExpandButton, CollapsibleContent,
  DetailsGrid, DetailCard, DetailTitle, DetailContent,
  ParticipantsSection, ParticipantsHeader, ParticipantsIcon,
  ParticipantsTitle, ParticipantsGrid, ModalOverlay, ModalContent,
  SnackbarContainer, pulse, float, fadeIn, shimmer
} from '../sharedStyles'
import { getEventTicket, getPublicEventTicket } from 'api'
import { Modal } from '@mui/material'
import LoadingBody from 'components/molecules/loadingBody/container';
import EventMessagesSystem from './eventMessageSystem'

const EventTicket = () => {

  const { t } = useTranslation()
  const params = useParams()
  const { slug } = params
  const [theParticipants, setParticipants] = useState([])
  const [myTicket, setMyTicket] = useState(null)
  const [theEvent, setEvent] = useState([])
  const [userModal, setUserModal] = useState(false)
  const [joinModal, setJoinModal] = useState(false)
  const [messagesOpen, setMessagesOpen] = useState(false)
  const [selectedParticipant, setSelectedParticipant] = useState(null)
  const [loggedIn, setLoggedIn] = useState(localStorage.getItem('token'))
  const [featuredParticipant, setFeaturedParticipant] = useState(null)
  const [unreadMessages, setUnreadMessages] = useState(3) // This would come from your messages API
  const [showComposer, setShowComposer] = useState(false)
  const [messageText, setMessageText] = useState('')

  function loadModal(participant) {
    setSelectedParticipant(participant)
    setUserModal(true)
  }

  function getTicketInfo(firstLoad) {
    if (loggedIn) {
      getEventTicket(slug).then(r => {
        setEvent(r.event)
        setParticipants(r.event.active_tickets)
        setMyTicket(r.event.my_ticket)
        if (r.event?.my_ticket?.status === 'PU' && firstLoad) {
          setJoinModal(true)
        }
      })
        .catch(console.error)
    } else {
      getPublicEventTicket(slug).then(r => {
        setEvent(r.event)
        setParticipants(r.event.active_tickets)
        setMyTicket(r.event.my_ticket)
        if (r.event?.my_ticket?.status === 'PU' && firstLoad) {
          setJoinModal(true)
        }
      })
        .catch(console.error)
    }
  }

  function closeAndReload() {
    getTicketInfo(false)
    setUserModal(false)
    setFeaturedParticipant(null)
  }

  useEffect(() => {
    getTicketInfo(true)
  }, [])

  useEffect(() => {
    if (featuredParticipant !== null) {
      theParticipants.map((item) => {
        if (item.slug === featuredParticipant) {
          loadModal(item)
        }
      })
    }
  }, [featuredParticipant])

  // Format date and time helpers
  const formatDate = (dateTimeString) => {
    if (!dateTimeString) return '';
    const date = new Date(dateTimeString);
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
  }

  const formatDateFull = (dateTimeString) => {
    if (!dateTimeString) return '';
    const date = new Date(dateTimeString);
    return date.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
  }

  const formatTime = (dateTimeString) => {
    if (!dateTimeString) return '';
    const date = new Date(dateTimeString);
    return date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
  }

  const formattedDate = formatDate(theEvent.start);
  const formattedDateFull = formatDateFull(theEvent.start);
  const formattedStart = formatTime(theEvent.start);
  const formattedEnd = formatTime(theEvent.end);

  const baseUrl = window.location.origin;
  const shareUrl = `${baseUrl}/event-ticket/${theEvent.slug}`;
  const [showDetails, setShowDetails] = useState(false);
  const toggleDetails = () => setShowDetails(prev => !prev);

  // Sidebar action handlers
  const handleMessagesClick = () => {
    setMessagesOpen(true)
    setUnreadMessages(0) // Mark as read when opened
  }

  const handleProfileClick = () => {
    setJoinModal(true)
  }

  const handleRefreshClick = () => {
    getTicketInfo(false)
  }

  // Check if profile update is needed
  const needsProfileUpdate = myTicket?.status === 'PU' || !myTicket?.user?.description

  // Mock messages data
  const mockMessages = [
    {
      id: 1,
      author: { name: "Event Organizer", role: "Host", avatar: "E" },
      content: "Welcome everyone! We're excited to have you join us for this amazing event.",
      type: "announcement",
      timestamp: "2 hours ago"
    },
    {
      id: 2,
      author: { name: "Sarah Wilson", role: "Attendee", avatar: "S" },
      content: "Looking forward to the networking session! Anyone interested in discussing AI?",
      type: "message",
      timestamp: "1 hour ago"
    },
    {
      id: 3,
      author: { name: "Event Team", role: "Staff", avatar: "T" },
      content: "⚠️ Important: The main entrance will be closed from 2-3 PM.",
      type: "urgent",
      timestamp: "30 minutes ago"
    }
  ]

  const handleSendMessage = () => {
    if (messageText.trim()) {
      // Mock sending message
      
      // Add the new message to the list (in a real app, this would be handled by your API)
      const newMessage = {
        id: Date.now(),
        author: { 
          name: myTicket?.user?.first_name + ' ' + myTicket?.user?.last_name || "You", 
          role: "Attendee", 
          avatar: myTicket?.user?.first_name?.charAt(0) || "U" 
        },
        content: messageText,
        type: "message",
        timestamp: "Just now"
      }
      
      // In a real app, you'd update your messages state here
      // setMessages(prev => [newMessage, ...prev])
      
      // Clear the composer
      setMessageText('')
      setShowComposer(false)
      
      // Show success feedback
      alert('Message sent successfully!')
    }
  }

  return (
    <Container>
      {/* Animated Background Elements */}
      <BackgroundOrb className="orb-1" duration="8s" />
      <BackgroundOrb className="orb-2" duration="6s" reverse />

      {theEvent?.length === 0 && <LoadingBody />}
      <ContentWrapper>
        {/* Hero Section */}
        <HeroSection>
          <HeroContent>
            <HeroGrid>
              <HeroMain>
                <EventHeader>
                  <EventIcon>
                    {/* Icon */}
                    <span style={{ fontSize: '28px' }}>🎟️</span>
                  </EventIcon>

                  <EventInfo>
                    <DateInfo>
                      {/* Calendar icon */}
                      <span style={{ marginRight: '8px', color: '#10b981' }}>📅</span>
                      <DateText>
                        {formattedDate}, {formattedStart} - {formattedEnd}
                      </DateText>
                    </DateInfo>

                    <EventTitle>
                      {theEvent?.name}
                    </EventTitle>

                    <VenueInfo>
                      {/* Location icon */}
                      <span style={{ marginRight: '8px', color: '#f59e0b' }}>📍</span>
                      <VenueLink
                        href={theEvent?.venue?.gmaps_address}
                        target="_blank"
                        rel="noopener"
                      >
                        {theEvent?.venue?.name} - {theEvent?.venue?.single_address}
                      </VenueLink>
                    </VenueInfo>
                  </EventInfo>
                </EventHeader>

                {/* Quick Stats */}
                <StatsContainer>
                  <StatBadge color="green">
                    {/* People icon */}
                    <span style={{ marginRight: '8px' }}>👥</span>
                    <span>{theParticipants?.length || 0} attending</span>
                  </StatBadge>

                  <StatBadge color="orange">
                    {/* Clock icon */}
                    <span style={{ marginRight: '8px' }}>🕓</span>
                    <span>
                      {theEvent?.start && theEvent?.end
                        ? Math.round((new Date(theEvent?.end) - new Date(theEvent?.start)) / (1000 * 60 * 60))
                        : 0} hours
                    </span>
                  </StatBadge>
                </StatsContainer>
              </HeroMain>

              <HeroAside>
                <ShareCard>
                  <ShareHeader>
                    {/* Share icon */}
                    <span style={{ marginRight: '8px', fontSize: '20px' }}>🔗</span>
                    <ShareTitle>Share Event</ShareTitle>
                  </ShareHeader>
                  <div style={{
                    background: 'white',
                    padding: '10px',
                    borderRadius: '8px',
                    textAlign: 'center',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    color: '#333'
                  }}>
                    {shareUrl}
                  </div>
                </ShareCard>
              </HeroAside>
            </HeroGrid>

            {/* Expandable Details */}
            <DetailsSection>
              <ExpandButton onClick={toggleDetails}>
                {showDetails ? '↑' : '↓'} {showDetails ? 'Less' : 'More'} details
              </ExpandButton>

              <CollapsibleContent isOpen={showDetails}>
                <DetailsGrid>
                  {theEvent?.description && (
                    <DetailCard>
                      <DetailTitle color="#10b981">About the event</DetailTitle>
                      <DetailContent>{theEvent.description}</DetailContent>
                    </DetailCard>
                  )}

                  {theEvent?.instructions && theEvent.instructions !== "" && (
                    <DetailCard>
                      <DetailTitle color="#8b5cf6">General Information</DetailTitle>
                      <DetailContent dangerouslySetInnerHTML={{ __html: theEvent.instructions }} />
                    </DetailCard>
                  )}

                  <DetailCard>
                    <DetailTitle color="#06b6d4">When</DetailTitle>
                    <DetailContent>
                      {formattedDateFull}, {formattedStart} - {formattedEnd}
                    </DetailContent>
                  </DetailCard>

                  <DetailCard>
                    <DetailTitle color="#f59e0b">Where</DetailTitle>
                    <DetailContent>
                      <VenueLink
                        href={theEvent?.venue?.gmaps_address}
                        target="_blank"
                        rel="noopener"
                      >
                        {theEvent?.venue?.single_address}
                      </VenueLink>
                    </DetailContent>
                  </DetailCard>
                </DetailsGrid>
              </CollapsibleContent>
            </DetailsSection>
          </HeroContent>
        </HeroSection>

        {/* Participants Section */}
        <ParticipantsSection>
          <ParticipantsHeader>
            <ParticipantsIcon>
              <span style={{ fontSize: '16px', color: 'white' }}>👥</span>
            </ParticipantsIcon>
            <ParticipantsTitle>
              Event Attendees ({theParticipants?.length || 0})
            </ParticipantsTitle>
          </ParticipantsHeader>

          <ParticipantsGrid>
            {theParticipants && theParticipants.map((participant, index) => (
              <div key={index} onClick={() => loadModal(participant)}
                style={{
                  cursor: 'pointer',
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  borderRadius: '20px',
                  padding: '16px',
                  position: 'relative',
                  overflow: 'hidden',
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
                  minHeight: '140px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: 'center'
                }}>
                <div style={{
                  width: '60px',
                  height: '60px',
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, #06b6d4 0%, #3b82f6 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '12px',
                  border: '3px solid rgba(255, 255, 255, 0.2)',
                  fontSize: '20px',
                  fontWeight: 'bold',
                  color: 'white'
                }}>
                  {participant?.user?.first_name?.charAt(0) || '?'}
                </div>
                <div style={{ color: 'white', fontSize: '14px', fontWeight: '600', marginBottom: '4px' }}>
                  {participant?.user?.first_name || 'Guest'}
                </div>
                <div style={{ color: 'rgba(255, 255, 255, 0.8)', fontSize: '12px' }}>
                  {participant?.user?.alias || 'Member'}
                </div>
              </div>
            ))}
          </ParticipantsGrid>
        </ParticipantsSection>
      </ContentWrapper>

      {/* Original Components */}
      <EventUpsell theEvent={theEvent} setFeaturedParticipant={setFeaturedParticipant} />

      {/* Modals */}
      <EventModalParticipant
        selectedParticipant={selectedParticipant}
        myTicket={myTicket}
        visibleModal={userModal}
        onClose={() => closeAndReload()}
      />

      <Modal
        open={joinModal}
        onClose={() => setJoinModal(false)}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <ModalContent
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto',
            maxWidth: '600px',
            width: '90%',
            position: 'relative'
          }}
        >
          <ModalCloseButton onClick={() => setJoinModal(false)} />
          <EventTicketUpdate
            myTicket={myTicket}
            visibleModal={(visible) => setJoinModal(visible)}
            event={theEvent}
            reload={() => getTicketInfo()}
          />
        </ModalContent>
      </Modal>

      {/* Messages Modal */}
      <Modal
        open={messagesOpen}
        onClose={() => setMessagesOpen(false)}
        aria-labelledby="messages-modal-title"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <div style={{
          background: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)',
          borderRadius: '24px',
          width: '90%',
          maxWidth: '500px',
          maxHeight: '80vh',
          overflow: 'hidden',
          position: 'relative',
          padding: '24px',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          boxShadow: '0 32px 64px rgba(0, 0, 0, 0.5)'
        }}>
          <div 
            style={{
              position: 'absolute',
              top: '16px',
              right: '16px',
              background: 'rgba(255, 255, 255, 0.1)',
              border: 'none',
              borderRadius: '50%',
              width: '32px',
              height: '32px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              color: 'rgba(255, 255, 255, 0.7)',
              transition: 'all 0.3s ease',
            }}
            onClick={() => setMessagesOpen(false)}
            onMouseEnter={(e) => {
              e.target.style.background = 'rgba(255, 255, 255, 0.2)'
              e.target.style.color = 'white'
              e.target.style.transform = 'scale(1.1)'
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'rgba(255, 255, 255, 0.1)'
              e.target.style.color = 'rgba(255, 255, 255, 0.7)'
              e.target.style.transform = 'scale(1)'
            }}
          >
            ✕
          </div>
          
          <div style={{
            marginBottom: '24px',
            textAlign: 'center'
          }}>
            <h3 style={{
              color: 'white',
              fontSize: '20px',
              fontWeight: '700',
              margin: '0 0 8px 0',
              background: 'linear-gradient(135deg, #fff 0%, #e5e7eb 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }}>
              Event Messages
            </h3>
            <div style={{
              color: 'rgba(255, 255, 255, 0.7)',
              fontSize: '14px'
            }}>
              Stay updated with announcements and connect with other attendees
            </div>
          </div>

          <div style={{
            maxHeight: '400px',
            overflowY: 'auto',
            marginBottom: '20px'
          }}>
            {/* Show composer if active */}
            {showComposer && (
              <div style={{
                background: 'rgba(102, 126, 234, 0.1)',
                border: '1px solid rgba(102, 126, 234, 0.3)',
                borderRadius: '16px',
                padding: '20px',
                marginBottom: '16px',
                animation: 'slideDown 0.3s ease-out'
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '16px'
                }}>
                  <div style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    fontWeight: '700',
                    fontSize: '12px',
                    marginRight: '12px'
                  }}>
                    {myTicket?.user?.first_name?.charAt(0) || 'U'}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{
                      color: '#667eea',
                      fontWeight: '600',
                      fontSize: '13px'
                    }}>
                      Writing as {myTicket?.user?.first_name || 'Anonymous'}
                    </div>
                    <div style={{
                      color: 'rgba(102, 126, 234, 0.8)',
                      fontSize: '11px'
                    }}>
                      Attendee • Visible to all participants
                    </div>
                  </div>
                  <button
                    onClick={() => setShowComposer(false)}
                    style={{
                      background: 'none',
                      border: 'none',
                      color: 'rgba(102, 126, 234, 0.7)',
                      cursor: 'pointer',
                      padding: '4px',
                      borderRadius: '4px',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = 'rgba(102, 126, 234, 0.2)'
                      e.target.style.color = '#667eea'
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = 'none'
                      e.target.style.color = 'rgba(102, 126, 234, 0.7)'
                    }}
                  >
                    ✕
                  </button>
                </div>

                <textarea
                  value={messageText}
                  onChange={(e) => setMessageText(e.target.value)}
                  placeholder="Share your thoughts, ask questions, or start a conversation..."
                  style={{
                    width: '100%',
                    minHeight: '80px',
                    background: 'rgba(255, 255, 255, 0.1)',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    borderRadius: '12px',
                    padding: '12px',
                    color: 'white',
                    fontSize: '14px',
                    fontFamily: 'inherit',
                    resize: 'vertical',
                    transition: 'all 0.3s ease',
                    boxSizing: 'border-box'
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#667eea'
                    e.target.style.background = 'rgba(255, 255, 255, 0.15)'
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = 'rgba(255, 255, 255, 0.2)'
                    e.target.style.background = 'rgba(255, 255, 255, 0.1)'
                  }}
                />

                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginTop: '12px'
                }}>
                  <div style={{
                    color: 'rgba(102, 126, 234, 0.7)',
                    fontSize: '12px'
                  }}>
                    {messageText.length}/500 characters
                  </div>
                  <div style={{
                    display: 'flex',
                    gap: '8px'
                  }}>
                    <button
                      onClick={() => setShowComposer(false)}
                      style={{
                        background: 'rgba(255, 255, 255, 0.1)',
                        border: '1px solid rgba(255, 255, 255, 0.2)',
                        borderRadius: '8px',
                        padding: '8px 16px',
                        color: 'rgba(255, 255, 255, 0.7)',
                        fontSize: '12px',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.background = 'rgba(255, 255, 255, 0.2)'
                        e.target.style.color = 'white'
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.background = 'rgba(255, 255, 255, 0.1)'
                        e.target.style.color = 'rgba(255, 255, 255, 0.7)'
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleSendMessage}
                      disabled={!messageText.trim()}
                      style={{
                        background: messageText.trim() 
                          ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' 
                          : 'rgba(255, 255, 255, 0.1)',
                        border: 'none',
                        borderRadius: '8px',
                        padding: '8px 16px',
                        color: messageText.trim() ? 'white' : 'rgba(255, 255, 255, 0.5)',
                        fontSize: '12px',
                        fontWeight: '600',
                        cursor: messageText.trim() ? 'pointer' : 'not-allowed',
                        transition: 'all 0.3s ease',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px'
                      }}
                      onMouseEnter={(e) => {
                        if (messageText.trim()) {
                          e.target.style.background = 'linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%)'
                          e.target.style.transform = 'translateY(-1px)'
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (messageText.trim()) {
                          e.target.style.background = 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                          e.target.style.transform = 'translateY(0)'
                        }
                      }}
                    >
                      🚀 Send
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Messages List */}
            {mockMessages.map((message) => (
              <div key={message.id} style={{
                background: 'rgba(255, 255, 255, 0.05)',
                borderRadius: '16px',
                padding: '16px',
                marginBottom: '12px',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                transition: 'all 0.3s ease'
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '8px'
                }}>
                  <div style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    fontWeight: '700',
                    fontSize: '12px',
                    marginRight: '12px'
                  }}>
                    {message.author.avatar}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{
                      color: 'white',
                      fontWeight: '600',
                      fontSize: '13px'
                    }}>
                      {message.author.name}
                    </div>
                    <div style={{
                      color: 'rgba(255, 255, 255, 0.6)',
                      fontSize: '11px'
                    }}>
                      {message.author.role} • {message.timestamp}
                    </div>
                  </div>
                  <div style={{
                    padding: '4px 8px',
                    borderRadius: '12px',
                    fontSize: '10px',
                    fontWeight: '600',
                    textTransform: 'uppercase',
                    background: message.type === 'announcement' ? 'rgba(59, 130, 246, 0.2)' :
                               message.type === 'urgent' ? 'rgba(239, 68, 68, 0.2)' :
                               'rgba(139, 92, 246, 0.2)',
                    color: message.type === 'announcement' ? '#60a5fa' :
                           message.type === 'urgent' ? '#f87171' :
                           '#a78bfa',
                    border: `1px solid ${message.type === 'announcement' ? 'rgba(59, 130, 246, 0.3)' :
                                        message.type === 'urgent' ? 'rgba(239, 68, 68, 0.3)' :
                                        'rgba(139, 92, 246, 0.3)'}`
                  }}>
                    {message.type}
                  </div>
                </div>
                <div style={{
                  color: 'rgba(255, 255, 255, 0.9)',
                  fontSize: '14px',
                  lineHeight: '1.4'
                }}>
                  {message.content}
                </div>
              </div>
            ))}
          </div>

          <button 
            onClick={() => setShowComposer(!showComposer)}
            style={{
              width: '100%',
              padding: '12px 24px',
              background: showComposer 
                ? 'rgba(255, 255, 255, 0.1)' 
                : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              border: showComposer ? '1px solid rgba(255, 255, 255, 0.2)' : 'none',
              borderRadius: '12px',
              color: 'white',
              fontWeight: '600',
              fontSize: '14px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px'
            }}
            onMouseEnter={(e) => {
              if (!showComposer) {
                e.target.style.background = 'linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%)'
                e.target.style.transform = 'translateY(-1px)'
              } else {
                e.target.style.background = 'rgba(255, 255, 255, 0.15)'
              }
            }}
            onMouseLeave={(e) => {
              if (!showComposer) {
                e.target.style.background = 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                e.target.style.transform = 'translateY(0)'
              } else {
                e.target.style.background = 'rgba(255, 255, 255, 0.1)'
              }
            }}
          >
            {showComposer ? '📝 Cancel writing' : '✏️ Write a message'}
          </button>
        </div>
      </Modal>

      {/* Expandable Sidebar - replaces the old floating button */}
      <ExpandableSidebar
        unreadMessages={unreadMessages}
        needsProfileUpdate={needsProfileUpdate}
        onMessagesClick={handleMessagesClick}
        onProfileClick={handleProfileClick}
        onRefreshClick={handleRefreshClick}
        currentUser={myTicket?.user}
      />

      {/* CSS Animations */}
      <style dangerouslySetInnerHTML={{
        __html: `
          @keyframes slideDown {
            from {
              opacity: 0;
              transform: translateY(-20px);
              max-height: 0;
            }
            to {
              opacity: 1;
              transform: translateY(0);
              max-height: 300px;
            }
          }
        `
      }} />
    </Container>
  )
}

EventTicket.propTypes = {}

export default EventTicket